export const medicationLogScheduledAt = (log) => {
    const dateRaw = log.plannedDate ?? log.planned_date;
    const timeRaw = log.remindTime ?? log.remind_time ?? log.time;
    if (!dateRaw || !timeRaw) return null;

    let year;
    let month;
    let day;

    const parsedDate = new Date(dateRaw);
    if (!Number.isNaN(parsedDate.getTime())) {
        year = parsedDate.getFullYear();
        month = parsedDate.getMonth() + 1;
        day = parsedDate.getDate();
    } else {
        const datePart = String(dateRaw).split('T')[0];
        const datePieces = datePart.split('-');
        if (datePieces.length !== 3) return null;
        year = parseInt(datePieces[0], 10);
        month = parseInt(datePieces[1], 10);
        day = parseInt(datePieces[2], 10);
        if (!year || !month || !day) return null;
    }

    const timePieces = String(timeRaw).split(':');
    if (timePieces.length < 2) return null;
    const hour = parseInt(timePieces[0], 10);
    const minute = parseInt(timePieces[1], 10);
    if (!Number.isFinite(hour) || !Number.isFinite(minute)) return null;

    return new Date(year, month - 1, day, hour, minute);
};

export const formatMedicationDueAt = (log) => {
    const scheduled = medicationLogScheduledAt(log);
    if (!scheduled) return '';
    const dd = String(scheduled.getDate()).padStart(2, '0');
    const mm = String(scheduled.getMonth() + 1).padStart(2, '0');
    const hh = String(scheduled.getHours()).padStart(2, '0');
    const min = String(scheduled.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${scheduled.getFullYear()} ${hh}:${min}`;
};

export const isMedicationDue = (log) => {
    const scheduled = medicationLogScheduledAt(log);
    if (!scheduled) return true;
    return Date.now() >= scheduled.getTime();
};

export const medicationTooEarlyMessage = (log) => {
    const dueAt = formatMedicationDueAt(log);
    if (!dueAt) return 'Chưa đến giờ uống thuốc';
    return `Chưa đến giờ uống thuốc (${dueAt})`;
};

export const canConfirmMedicationTaken = (log) => {
    const status = (log.status || 'pending').toString();
    return status === 'pending' || status === 'missed';
};
